import React from 'react'

import { adminUserAccounts } from '../../../core/controllers/Admin/AdminUserAccounts'

export default class NeedApprovalManagersCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            totalNeedApprovalManagers: 0
        };
    }

    componentDidMount() {
        var self = this;
        adminUserAccounts.getUsers(function(response) {
            var count = 0;
            response.data.map(function(account){
                if (account.user.user_type_alias == "admin" && account.user.accepts_payments != 1) {
                    count += 1
                }
            })
            self.setState({
                totalNeedApprovalManagers: count
            })
        });
    }

    render() {
        const totalNeedApprovalManagers = this.state.totalNeedApprovalManagers;
        return (
            <div class="col-md-3 col-sm-6 col-xs-12">
                <div class="info-box">
                    <span class="info-box-icon red-icon-circle"><i class="icon-alert"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text">Need Approval</span>
                        <br/>
                        <span class="info-box-subtext">Billing account set up</span>
                        <span class="info-box-number red-info-number">{totalNeedApprovalManagers}</span>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Admin/Users/NeedApprovalManagersCard.jsx